/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getInsuranceClaims } from 'app/entities/insurance-claim/insurance-claim.reducer';
import { InsuranceClaimStatus } from 'app/shared/model/enumerations/insurance-claim-status.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';
import { createEntity, getEntity, reset, updateEntity } from './insurance-claim-history.reducer';

export const InsuranceClaimHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const insuranceClaims = useAppSelector(state => state.insuranceClaim.entities);
  const insuranceClaimHistoryEntity = useAppSelector(state => state.insuranceClaimHistory.entity);
  const loading = useAppSelector(state => state.insuranceClaimHistory.loading);
  const updating = useAppSelector(state => state.insuranceClaimHistory.updating);
  const updateSuccess = useAppSelector(state => state.insuranceClaimHistory.updateSuccess);
  const insuranceClaimStatusValues = Object.keys(InsuranceClaimStatus);
  const paymentStatusValues = Object.keys(PaymentStatus);

  const handleClose = () => {
    navigate(`/insurance-claim-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getInsuranceClaims({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...insuranceClaimHistoryEntity,
      ...values,
      claim: insuranceClaims.find(it => it.id.toString() === values.claim?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
          lastUpdated: displayDefaultDateTime(),
        }
      : {
          status: 'REJECTED',
          paymentStatus: 'ENTERED',
          ...insuranceClaimHistoryEntity,
          microSec: convertDateTimeFromServer(insuranceClaimHistoryEntity.microSec),
          timestampEntry: convertDateTimeFromServer(insuranceClaimHistoryEntity.timestampEntry),
          lastUpdated: convertDateTimeFromServer(insuranceClaimHistoryEntity.lastUpdated),
          claim: insuranceClaimHistoryEntity?.claim?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.insuranceClaimHistory.home.createOrEditLabel" data-cy="InsuranceClaimHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.home.createOrEditLabel">
              Create or edit a InsuranceClaimHistory
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="insurance-claim-history-id"
                  label={translate('tinyMedicRestApp.insuranceClaimHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.insuranceClaimHistory.status')}
                id="insurance-claim-history-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {insuranceClaimStatusValues.map(insuranceClaimStatus => (
                  <option value={insuranceClaimStatus} key={insuranceClaimStatus}>
                    {translate(`tinyMedicRestApp.InsuranceClaimStatus.${insuranceClaimStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.insuranceClaimHistory.paymentStatus')}
                id="insurance-claim-history-paymentStatus"
                name="paymentStatus"
                data-cy="paymentStatus"
                type="select"
              >
                {paymentStatusValues.map(paymentStatus => (
                  <option value={paymentStatus} key={paymentStatus}>
                    {translate(`tinyMedicRestApp.PaymentStatus.${paymentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.insuranceClaimHistory.active')}
                id="insurance-claim-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.insuranceClaimHistory.microSec')}
                id="insurance-claim-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.insuranceClaimHistory.timestampEntry')}
                id="insurance-claim-history-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.insuranceClaimHistory.lastUpdated')}
                id="insurance-claim-history-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.insuranceClaimHistory.cursor')}
                id="insurance-claim-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="insurance-claim-history-claim"
                name="claim"
                data-cy="claim"
                label={translate('tinyMedicRestApp.insuranceClaimHistory.claim')}
                type="select"
              >
                <option value="" key="0" />
                {insuranceClaims
                  ? insuranceClaims.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/insurance-claim-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InsuranceClaimHistoryUpdate;
